<template>
  <div style='margin-top: -10px' class="container">
    <div style='border-bottom: 1px #ececec solid;padding-bottom: 10px;'>
      <el-button type="primary" @click="returnFn()">返回列表</el-button>
    </div>
    <div class='descriptionsBox'>
      <el-descriptions title="服务对象信息" :column='4'>
        <template slot="extra"><span class='extraSpan'>{{ rowData.userInfo.result === 1 ? '住院中' : '已出院' }}</span></template>
        <el-descriptions-item label="姓名">{{ rowData.userInfo.name }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ rowData.userInfo.tel }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ rowData.orderInfo.id_card }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column='4'>
        <el-descriptions-item label="所在乡镇">{{ rowData.userInfo.town }}</el-descriptions-item>
        <el-descriptions-item label="所在医院">{{ rowData.userInfo.hospital_name }}</el-descriptions-item>
        <el-descriptions-item label="自理能力评估">
          <span v-if='rowData.orderInfo.power == 1'>完全自理</span>
          <span v-if='rowData.orderInfo.power == 2'>部分自理</span>
          <span v-if='rowData.orderInfo.power == 3'>不能自理</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column='4'>
        <el-descriptions-item label="住院日期">{{ (rowData.userInfo.start_at * 1000) | formatDate('yyyy-MM-dd') }}</el-descriptions-item>
        <el-descriptions-item label="出院日期"><span v-if="rowData.userInfo.result === 2">{{(rowData.userInfo.end_at * 1000) | formatDate('yyyy-MM-dd')}}</span></el-descriptions-item>
      </el-descriptions>
      <el-descriptions>
        <el-descriptions-item label="具体楼宇、科室、楼层、病床号">{{ rowData.userInfo.address }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions>
        <el-descriptions-item label="服务对象照片">
          <div class="imgbox">
            <el-image class='litimg' v-for="(img, key) in rowData.orderInfo.img_urls" :key="key" :src="img" :preview-src-list="rowData.img" />
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class='mt30' title="申请人信息" :column='5'>
        <el-descriptions-item label="姓名">{{ rowData.applyInfo.applicant }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ rowData.applyInfo.apply_phone }}</el-descriptions-item>
        <el-descriptions-item label="申请人与服务对象关系">
          <span v-if='rowData.applyInfo.relation == 1'>本人</span>
          <span v-if='rowData.applyInfo.relation == 2'>代理人（亲友）</span>
          <span v-if='rowData.applyInfo.relation == 3'>村居委民政专干</span>
          <span v-if='rowData.applyInfo.relation == 4'>其他</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class='mt30' title="护工信息" :column='5'>
        <template slot="extra">
          <el-button v-if='rulesArr.includes("3") && rowData.userInfo.result === 1' type="primary" @click="showEditDialog(rowData)">添加/更换护工</el-button>
        </template>
        <el-descriptions-item label="姓名">{{ rowData.nurseInfo[0] ? rowData.nurseInfo[0].name : '' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ rowData.nurseInfo[0] ? rowData.nurseInfo[0].tel : '' }}</el-descriptions-item>
        <el-descriptions-item v-if="rulesArr.includes('3')" label="护工佣金">{{ rowData.nurseInfo[0] ? rowData.nurseInfo[0].price : '' }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions class='mt30' title="护理记录" :column='1' />
      <div class='tableBoxW'>
        <div class='tableBox'>
          <el-table :data="rowData.nurseRecordsInfo" style="width: 100%">
            <el-table-column type="index" width="100"></el-table-column>
            <el-table-column minWidth="180">
                <template slot-scope="scope">
                  <div>{{ scope.row.name }}</div>
                  <div>{{ scope.row.tel }}</div>
                  <div>开始时间：{{ (scope.row.service_at * 1000) | formatDate('yyyy-MM-dd HH:mm:ss') }}</div>
                </template>
            </el-table-column>
            <el-table-column v-if="rulesArr.includes('3')" minWidth="120">
              <template slot-scope="scope">佣金:{{ scope.row.services_total }}</template>
            </el-table-column>
            <el-table-column minWidth="220">
              <template slot-scope="scope">
                <div>服务中照片:</div>
                <div class="imgbox">
                  <el-image
                    class='litimg2'
                    v-for="(img, key) in scope.row.img_urls"
                    :src="img"
                    :key="key"
                    :preview-src-list="scope.row.img_urls">
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column minWidth="120">
              <template slot-scope="scope">
                <div v-if='!!scope.row.modificationTime && scope.row.status !== "已结束" '>
                  <span v-if='(Date.parse((scope.row.modificationTime).replace(/-/g, "/")) > thisDate)'>今日已更新</span>
                  <span style='color: red' v-if='!(Date.parse((scope.row.modificationTime).replace(/-/g, "/")) > thisDate)'>今日未更新</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="isAdmin" width="60">
              <template slot-scope="scope">
                <el-link v-if="scope.$index ===  rowData.nurseRecordsInfo.length - 1" type="danger" @click="handleDelete(scope.row.id)">
                  <el-icon name="delete-solid"></el-icon>
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :title="editFormTitle" :visible.sync="editVisible" width="600px" center>
      <el-form :model="editForm">
        <el-form-item label="选择护理员" :label-width="formLabelWidth">
          <el-select v-model="editForm.nurse_id" style="width: 100%" allow-create filterable default-first-option placeholder="请选择护工">
            <el-option
              v-for="hospital in nurses"
              :label="`${hospital.name}/${hospital.tel}`"
              :value="hospital.id"
              :key="hospital.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="护理员佣金" :label-width="formLabelWidth">
          <el-input v-model="editForm.price" placeholder="请输入护理员佣金" @input='inputFn("price")'></el-input>
        </el-form-item>
        <el-form-item label="服务对象自理能力评估" :label-width="formLabelWidth">
          <el-select class='w100' v-model="editForm.power" placeholder="请选择">
            <el-option label="请选择..." value=""></el-option>
            <el-option label="完全自理" value="1"></el-option>
            <el-option label="部分自理" value="2"></el-option>
            <el-option label="不能自理" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { delOrderServiceById, destituteAllocate, destituteDetail, fetchNurseList } from '@/api'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { color } from 'mockjs/src/mock/random/color'
import { isAdmin } from '@/utils/util'
export default {
  data() {
    const isDate = new Date()
    const { rules } = this.$store.state
    let rulesArr = rules.filter(i => Number(i.id) === 13)[0].child
    if (typeof rulesArr !== 'undefined') rulesArr = Object.values(rulesArr).map(mapData => mapData.id)
    return {
      rowDataId: '',
      fileList: [],
      rulesArr: rulesArr || [],
      thisDateS: `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()}`,
      thisDate: Date.parse(`${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} 00:00:00`),
      rowData: { userInfo: {}, orderInfo: {}, applyInfo: {}, nurseInfo: [{}], nurseRecordsInfo: [] },
      editVisible: false,
      editForm: {
        order_id: '',
        nurse_id: '',
        price: '',
        power: ''
      },
      editFormTitle: '',
      formLabelWidth: '153px',
      tableDataAdd: { },
      tableData: [],
      nurses: []
    }
  },
  filters: {
    formatDate
  },
  computed: {
    isAdmin() {
      return isAdmin()
    }
  },
  mounted() {
    this.rowDataId = (location.search).split('id=')[1]
    this.getList()
  },
  methods: {
    color,
    returnFn() { this.$router.push('/orders_tk') },
    async getList() {
      const params = { order_id: this.rowDataId }
      destituteDetail(params)
        .then(res => {
          if (res.status) {
            this.rowData = res.data
          } else this.rowData = []
        })
      await this.getNurseList()
    },
    async getNurseList() {
      const { status, data } = await fetchNurseList()
      if (status) {
        console.log(data)
        this.nurses = data
      }
    },
    showEditDialog(row) {
      this.editVisible = true
      this.fileList = []
      this.editForm.order_id = row.orderInfo.id
      this.editFormTitle = (row.nurseInfo && row.nurseInfo[0]) ? '更换护工' : '添加护工'
    },
    handleEdit() {
      if (!this.editForm.nurse_id) return this.$message({ message: '请选择护理员！', type: 'warning' })
      if (!this.editForm.price) return this.$message({ message: '请添加护理员佣金！', type: 'warning' })
      if (!this.editForm.power) return this.$message({ message: '请选择服务对象自理能力评估！', type: 'warning' })
      const params = { ...this.editForm }
      destituteAllocate(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.$router.go(0)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleDelete(record_id) {
      this.$confirm(`确定删除护理纪录吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delOrderServiceById({
          record_id
        }).then(res => {
          if (res.status) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList()
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          }
        })
      }).catch(() => {
        console.log('取消删除')
      })
    },
    inputFn(_Text) {
      this.editForm[_Text] = (this.editForm[_Text]).replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.w100{width: 100%}
.mt30{margin-top: 30px}
.descriptionsBox{
  padding: 15px;
}
.extraSpan{
  font-size: 16px;
  color: #26A4B2;
  font-weight: 600;
}
.imgbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .litimg {
    width: 120px;
    height: 120px;
    margin: 5px;
    object-fit: cover;
    cursor: zoom-in;
  }
  .litimg2 {
    width: 40px;
    height: 40px;
    margin: 5px;
    object-fit: cover;
    cursor: zoom-in;
  }
}
.tableBoxW{
  overflow: hidden;
  .tableBox{
    margin-top: -50px;
  }
}
</style>
